module.exports = __webpack_public_path__ + "img/bleeding-edge-media.b3bdd377.jpg";